import React from "react";

const HelpBlock = (props) =>
<span className="form-text">{props.children}</span>;


export default HelpBlock;